import { render } from "./Dashboard.vue?vue&type=template&id=285fc060&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=285fc060&scoped=true&lang=scss"
import "./Dashboard.vue?vue&type=style&index=1&id=285fc060&lang=css"
script.render = render
script.__scopeId = "data-v-285fc060"

export default script